import { Button, Typography, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import DialogActions from "../../../Common/Dialog/DialogActions";
import DialogContent from "../../../Common/Dialog/DialogContent";

const StyledDialogContent = styled(DialogContent)(({theme}) => ({
    padding: '60px 80px 30px',
    textAlign: 'center',

    ['@media (max-width: '+theme.breakpoints.values.dialog_mobile+'px)']: {
        padding: '30px 40px 20px',
    }
}));

interface Props {
    message?: string
    onClose?: () => void
}

export default function SaveError(props: Props) {
    const [t] = useTranslation('design-lab');

    return <>
        <StyledDialogContent>
            <Typography
                variant="h2"
                style={{
                    marginBottom: '10px',
                }}
            >{ t('We couldn\'t save your design') }</Typography>
            <Typography
                variant="body1"
            >{ props.message ?? t('Please try again.') }</Typography>
        </StyledDialogContent>
        <DialogActions>
            <Button onClick={props.onClose}>{t('Close')}</Button>
        </DialogActions>
    </>
}
